import React from 'react'

const OrderBasicDetails = ({children, label, isMoney}) => {
    return (
        <p>{label}: {isMoney && '$'} {children}</p>
    )
}

export default OrderBasicDetails
